import { Injectable } from "@angular/core";
import { AnalyticsService } from "../analytics.service";
import { CommonService } from "../common.service";
import { UserPreference } from "../../models/UserPreference";
import { appSettings, errorMessages } from "../../settings";
import * as moment from "moment";

@Injectable()
export class CurrentinventoryService {
  constructor(
    private _analyticsService: AnalyticsService,
    private _commonService: CommonService
  ) { }

  chartOptions() {
    return {
      draggable: false,
      resizable: false,
      loading: false,
      style: {},
      title: {
        show: true,
        text: '',
        textAlign: 'center',
        textBaseline: 'bottom',
        bottom: '-1%',
        left: 'center',
        textStyle: {
          color: '#ccc',
          fontWeight: 'lighter',
          fontSize: 14
        }
      },
      label: {
        normal: {
          show: true
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: "{a} <br/>{b}: {c} ({d}%)"
      },
      legend: {
        orient: 'vertical',
        top: 0,
        left: 0,
        data: [],
        icon: 'circle',
        textStyle: {
          color: '#999999',
        },
      },
      series: [{
        name: 'CurrentInventory',
        itemStyle: {
          normal: {
            label: {
              formatter: '{b} : \n{d}% ({c})',
              position: 'outside',
            },
            labelLine: {
              show: true
            }
          }
        },
        type: 'pie',
        //selectedMode: 'single',
        radius: ['40%', '70%'],
        label: {
          normal: {
            position: 'outside',
            testStyle: {
              fontSize: 5
            },
            offset: [-50, 50]
          },
          emphasis: {
            show: true,
            position: 'center',
            textStyle: {
              fontSize: '18',
              fontWeight: 'bold'
            }
          }
        },
        labelLine: {
          normal: {
            show: true
          }
        },
        data: []
      },
      ]
    };
  }

  init(widget: any) {
    console.log('CurrentInventoryService')
    widget.dataLoaded = false;
    widget.Title = 'Current Inventory';
    let userPref: UserPreference = this._commonService.getUserPreference();
    console.time('getMHCurrentInventory');
    this._analyticsService.getMHCurrentInventory(userPref.FacilityId, userPref.CustomerId)
      .subscribe((result: any) => {
        console.timeEnd('getMHCurrentInventory');
        console.log('getMHCurrentInventory', result);
        let Series1: Array<any> = [];
        widget.chartOptions = this.chartOptions();
        widget.errorMessage = null;
        if (result && result.length > 0) {
          widget.dataLoaded = false;

          Series1.push({
            value: result[0].ACTIVE_UNITS_COUNT,
            name: 'Active Units',
            //selected: true
          });
          Series1.push({
            value: result[0].RESERVE_UNITS_COUNT,
            name: 'Reserve Units'
          });
          Series1.push({
            value: result[0].NOT_PUTAWAY_COUNT,
            name: 'Not Putaway'
          });

          widget.chartOptions.title.text = 'On Hand Units : ' + result[0].ON_HAND_UNITS_COUNT;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }
        
        widget.chartOptions.color = ['#8cc63f', '#29abe2', '#e3ed74', '#44bd54', '#0080a8'];
        widget.chartOptions.series[0].data = Series1;

        //console.log(JSON.stringify(widget.chartOptions));
        widget.dataLoaded = true;
      }
        , err => {
          console.timeEnd('getMHCurrentInventory');
          console.log('getMHCurrentInventory', err);
          widget.dataLoaded = true;
        }
      );
  }

  reload(widget: any) { }

  remove(widget: any) { }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/currentinventory.service.ts